import MojitoPresentation from 'mojito/presentation';
import { useContainerItems } from 'modules/common/hooks/index.js';
import CountryOrSportIcon from 'modules/country-or-sport-icon/index.js';

const { FlexPane, ImageButton, Text } = MojitoPresentation.Components;
const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
const SortingHelper = MojitoPresentation.Utils.SortingHelper;
const { useScrollIntoView } = MojitoPresentation.Hooks;

export default function QuickLeaguesNavigation(props) {
    const {
        mojitoTools: { config, appContext },
        sportClassId,
        sportId,
        onItemClick,
        selectedTypeId,
    } = props;
    const containerId = appContext.subscriptionResolver.matchAllTypesByClass(sportId, sportClassId);
    const classContainerItems = useContainerItems(containerId);
    const sportClass = resolveSportClass(sportClassId, classContainerItems);
    const elementRef = useScrollIntoView();

    if (!sportClass) {
        return null;
    }
    const onLeagueClick = (event, typeId) => {
        IntentActionTrigger.showSportCompetitions(sportId, typeId);
        onItemClick(typeId);
    };
    const language = appContext.systemSettings().language;
    const leagues = sportClass.items ? [...sportClass.items] : [];
    leagues.sort((l1, l2) => SortingHelper.byDisplayOrderAndName(l1, l2, language));
    return (
        <FlexPane config={config.container}>
            <Header sportId={sportId} sportClass={sportClass} config={config} />
            <FlexPane config={config.leaguesContainer}>
                {leagues.map(league => {
                    const isActive = selectedTypeId === league.id;
                    return (
                        <ImageButton
                            key={league.id}
                            config={config.leagueItem}
                            label={league.name}
                            onClick={onLeagueClick}
                            active={isActive}
                            onClickData={league.id}
                            buttonElementRef={isActive ? elementRef : undefined}
                        />
                    );
                })}
            </FlexPane>
        </FlexPane>
    );
}

const Header = props => {
    const { config, sportClass, sportId } = props;
    const { countryCode, countryName } = sportClass;
    return (
        <FlexPane config={config.headerContainer}>
            <CountryOrSportIcon
                config={config.countryOrSportIcon}
                sportId={sportId}
                countryCode={countryCode}
                countryName={countryName}
            />
            <Text config={config.headerLabel}>{sportClass.name}</Text>
        </FlexPane>
    );
};

const resolveSportClass = (sportClassId, classItems = []) =>
    classItems.find(item => item.id === sportClassId);
